import React, { createContext, useContext, useState } from "react";

const KonvaContext = createContext({
    tool: null,
    setTool: () => { },
    shapes: [],
    setShapes: () => { },
    scale: 1,
    setScale: () => { },
    selectedShape: null,
    setSelectedShapeIndex: () => { },
    modalIsOpen: false,
    setModalIsOpen: () => { },
    sideDimensions: {},
    setSideDimensions: () => { },
    handleShapeClick: () => { },
    shapeAreas: {},
    setShapeAreas: () => { },
    shapeData: {},
    setShapeData: () => { },
    suggestDimension: [],
    setSuggestDimension: () => { }
})

export const KonvaProvider = ({ children }) => {
    const [tool, setTool] = useState(null)
    const [shapes, setShapes] = useState([])
    const [scale, setScale] = useState(1)
    const [selectedShapeId, setSelectedShapeId] = useState(null)
    const [modalIsOpen, setModalIsOpen] = useState(false)
    const [sideDimensions, setSideDimensions] = useState({})
    const [shapeAreas, setShapeAreas] = useState({})
    const [shapeData, setShapeData] = useState({})
    const [suggestDimension, setSuggestDimension] = useState([])
    const [selectedDimension, setSelectedDimension] = useState(null)
    const [shapesHistory, setShapesHistory] = useState([])
    const [future, setFuture] = useState([])
    const [selectedSuggestionIndex,setSelectedSuggestionIndex] = useState(null)
    const [isHelpModalOpen, setIsHelpModalOpen] = useState(true)
    const [selectedDimesionHistory,setSelectedDimensionHistory] = useState(null)

    const handleShapeClick = (id) => {
        const selectedShapeData = shapeData[id]
        setSelectedShapeId(id)
        setModalIsOpen(true)

        if (selectedShapeData) {
            setSideDimensions(selectedShapeData?.dimensions)
            setSuggestDimension(selectedShapeData?.possibleDimensions)
            setSelectedDimensionHistory(selectedShapeData?.currentSelectedDimension)
        } else {
            setSideDimensions({})
        }
    }

    return (
        <KonvaContext.Provider
            value={{
                tool,
                setTool,
                shapes,
                setShapes,
                scale,
                setScale,
                selectedShapeId,
                setSelectedShapeId,
                modalIsOpen,
                setModalIsOpen,
                sideDimensions,
                setSideDimensions,
                handleShapeClick,
                shapeAreas,
                setShapeAreas,
                shapeData,
                setShapeData,
                suggestDimension,
                setSuggestDimension,
                selectedDimension,
                setSelectedDimension,
                shapesHistory,
                setShapesHistory,
                future,
                setFuture,
                selectedSuggestionIndex,
                setSelectedSuggestionIndex,
                isHelpModalOpen, 
                setIsHelpModalOpen,
                selectedDimesionHistory,
                setSelectedDimensionHistory
            }}
        >
            {children}
        </KonvaContext.Provider>
    )
}

export const useKonva = () => useContext(KonvaContext)